export default {
  text: 'Vi gør dit bord klar 🍽…',
};
